import { render, staticRenderFns } from "./LeftSideMenuLv2.vue?vue&type=template&id=2f7b006b&scoped=true&"
import script from "./LeftSideMenuLv2.vue?vue&type=script&lang=js&"
export * from "./LeftSideMenuLv2.vue?vue&type=script&lang=js&"
import style0 from "./LeftSideMenuLv2.vue?vue&type=style&index=0&id=2f7b006b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7b006b",
  null
  
)

export default component.exports